import { Payload } from '@mjolnir/mf-fields-ts/src/Payload';
import { ContractOnboardingStatus } from '@mjolnir/mf-fields-ts/src/enm/ContractOnboardingStatus';

export enum Audience {
  WEB = 'WEB',
  IOS = 'IOS',
  ANDROID = 'ANDROID',
}

export enum ExitPointType {
  REDIRECT = 'REDIRECT',
  MESSAGE = 'MESSAGE',
}
export interface ExitPoint {
  audience: Audience;
  type: ExitPointType;
  exit_point: string;
}

export interface TermsAndConditionsPerMarket {
  url: string;
  label: string;
  fallback_label: string;
}

export interface TermsAndConditionsPayload {
  terms_and_conditions: TermsAndConditionsPerMarket[];
}

export interface BpcPayload {
  data?: Payload;
  status: ContractOnboardingStatus;
  krn?: string;
  must_agree_terms_and_conditions_before_underwriting?: boolean;
  terms_and_conditions?: TermsAndConditionsPerMarket[] | [];
  missing_additional_data?: string[];
  has_agreed_terms_and_conditions?: boolean;
  exit_points?: ExitPoint[];
}
